import React, { useState, FormEvent } from 'react';
import { Button } from '@/components/ui/button';
import { toast as sonnerToast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { submitMarketingLead } from '@/lib/leadCapture';

export const NewsletterCTA: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      sonnerToast.error('Please enter a valid email.');
      return;
    }

    setIsLoading(true);
    try {
      await submitMarketingLead({
        source: 'blog_newsletter',
        email,
        intent: 'blog_updates',
        pagePath: window.location.pathname,
      });

      sonnerToast.success('You are subscribed.');
      setEmail('');
    } catch (error: any) {
      console.error('Subscription error:', error);
      sonnerToast.error(error.message || 'Failed to subscribe. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="border-y border-slate-200 bg-slate-50 py-24">
      <div className="container mx-auto max-w-2xl px-4 text-center">
        <h2 className="mb-4 text-3xl font-bold text-slate-900">Get practical seller growth playbooks.</h2>
        <p className="mb-8 text-slate-600">Receive short updates on financing checkout strategy, follow-up timing, and close-rate improvement.</p>
        <form className="mx-auto flex max-w-md gap-2" onSubmit={handleSubscribe}>
          <input
            type="email"
            placeholder="Enter your email"
            className="h-12 flex-1 rounded-xl border border-slate-300 bg-white px-4 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
          />
          <Button size="lg" className="rounded-xl bg-emerald-600 px-8 text-white hover:bg-emerald-500" disabled={isLoading}>
            {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Subscribe'}
          </Button>
        </form>
      </div>
    </div>
  );
};
